/**
 * 범용 오버레이 모달 — DOM 루트 하나에 대화상자·백드롭·닫기 제어.
 * (utils/Modal.ts 의 alert/confirm 과 별도)
 */
export class Modal {
  protected readonly root: HTMLElement;
  private readonly onKeyDown: (e: KeyboardEvent) => void;

  public constructor(root: HTMLElement | string) {
    const el = typeof root === "string" ? document.querySelector<HTMLElement>(root) : root;
    if (!el) {
      throw new Error("Modal: root element not found");
    }
    this.root = el;
    this.onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        this.close();
      }
    };
  }

  public open(): void {
    this.root.hidden = false;
    this.root.setAttribute("aria-hidden", "false");
    document.body.classList.add("bro-modal-open");
    document.addEventListener("keydown", this.onKeyDown);
  }

  public close(): void {
    this.root.hidden = true;
    this.root.setAttribute("aria-hidden", "true");
    document.body.classList.remove("bro-modal-open");
    document.removeEventListener("keydown", this.onKeyDown);
  }

  protected bindDefaultClose(): void {
    this.root.querySelectorAll<HTMLElement>("[data-bro-modal-close]").forEach((node) => {
      node.addEventListener("click", () => this.close());
    });
    const backdrop = this.root.querySelector<HTMLElement>("[data-bro-modal-backdrop]");
    backdrop?.addEventListener("click", () => this.close());
  }
}
